import { ConnectionDto, mapConnectionUIName } from "@arelia-types/connection"
import ConnectionCard from "./ConnectionCard";
import { useState } from "react";
import BasicDialog from "../dialogs/BasicDialog";
import { Box, Button, Typography } from "@mui/material";
import { openAuthWindow } from "../helpers";

type Props = {
  connection: ConnectionDto,
}

export default function ConnectServiceConnection({ connection }: Props) {
  const [open, setOpen] = useState<boolean>(false);

  return <Box>
    <ConnectionCard {...connection} onConnect={() => setOpen(true)} />
    {open && <BasicDialog
      connection={connection}
      title={`${connection.name} connection`}
      onClose={() => setOpen(false)}
      canDisconnect={true}
      renderActions={() =>
        <Button
          variant="outlined"
          onClick={() => openAuthWindow(connection.name)}
        >
          {connection.connected ? 'Reconnect' : 'Connect'}
        </Button>
      }
    >
      {!connection.connected
        ?
        <Typography>
          Arelia is not connected to {mapConnectionUIName(connection.name)} yet.&nbsp;
          To connect your {mapConnectionUIName(connection.name)} account, simply click the
          <span style={{ color: "#00bcd4", fontWeight: 500 }}> Connect </span> button below.
        </Typography>
        :
        <Typography>Arelia has successfully connected to {mapConnectionUIName(connection.name)}{connection.login ? <> with account <b>{connection.login}</b></> : ''}.
        </Typography>}
    </BasicDialog>}
  </Box>;
}